export const toSeconds = timeStr => {
  let p = timeStr
    .toString()
    .split(":")
    .filter(val => val !== "");

  if (p[1] && p[1].length === 1) p[1] *= 10;

  let s = 0;
  let m = 1;

  while (p.length > 0) {
    s += m * parseInt(p.pop(), 10);
    m *= 60;
  }

  return s;
};

export const toMinutes = timeStr => {
  if (isNaN(timeStr)) {
    return "";
  }

  let h = Math.floor(timeStr / 3600);
  let m = Math.floor((timeStr - h * 3600) / 60);
  let s = timeStr - h * 3600 - m * 60;

  // round seconds
  s = Math.round(s * 100) / 100;

  let result = "";

  result += m < 10 ? "0" + m : m;
  result += ":" + (s < 10 ? "0" + s : s);

  return result;
};
